import React, { useState, useEffect } from 'react';
import UserSelectField from '../DebateArena/UserSelectField/UserSelectField';
import styles from './DebaterAssign.module.css';
import Button from '../ui/Button';


const DebaterAssign = ({
  custom,
  roles,
  currentUser,
  cache,
  setCache,
  resetSlots,
  setSearchTarget,
  setSearchTargetTeam,
  handleUserSelect
}) => {
  const [teamSlots, setTeamSlots] = useState([]);
  const [normalizedDebaters, setNormalizedDebaters] = useState([]);

  const totalSlots = custom?.participants || 0;
  const teamCount = custom?.teams?.length || 0;

  // Run setup only when data is ready
  useEffect(() => {
	  if (!custom || !roles?.debaters || teamCount === 0 || totalSlots === 0) return;

	  if (teamSlots.length === 0) {
		const base = Math.floor(totalSlots / teamCount);
		const extra = totalSlots % teamCount;
		const initialSlots = custom.teams.map((_, i) => base + (i < extra ? 1 : 0));
		setTeamSlots(initialSlots);
	  }

	  const filled = roles.debaters || [];
	  const padded = Array.from({ length: totalSlots }).map((_, i) => filled[i] || null);
	  setNormalizedDebaters(padded);
	}, [custom, roles]);

	useEffect(() => {
		if(resetSlots == false) {
			setTeamSlots([]);
		}
	}, [resetSlots]);


  const handleAdjust = (teamIdx, delta) => {
    const updated = [...teamSlots];
    updated[teamIdx] = Math.max(0, updated[teamIdx] + delta);
    const sum = updated.reduce((a, b) => a + b, 0);
    if (sum <= totalSlots) {
      setTeamSlots(updated);
    }
  };

  const getTeamColor = (ucolor) => {
  
	if (ucolor == "a" || ucolor == "gov" || ucolor == "team a" || ucolor == "plan" || ucolor == "pro"|| ucolor == "aff") {
		return "pro";
	}
	else if (ucolor == "debaters") {
		return "neutral";
	}
	
	return "con";
  }

  let globalIdx = 0;

  return (
    <div className={styles.debaterAssign}>
      {custom?.teams?.map((teamName, teamIdx) => {
        const slots = teamSlots[teamIdx] || 0;
        const debaters = normalizedDebaters.slice(globalIdx, globalIdx + slots);
        const filled = debaters.filter(Boolean).length;

        const elements = Array.from({ length: slots }).map((_, i) => {
          const index = globalIdx + i;
          const selected = normalizedDebaters[index];
          return (
            <UserSelectField
              key={index}
			  cache={cache}
              setCache={setCache}
			  currentUser={currentUser}
			  handleUserSelect={handleUserSelect}
			  setSearchTarget={setSearchTarget}
              label={`Debater #${index + 1}`}
              selected={selected}
              onPickUser={() => {setSearchTargetTeam(teamName); setSearchTarget(index);}}
              isCurrentUser={selected?.uid === currentUser.uid}
              onSelect={(user) => {
                const updated = [...normalizedDebaters];
                updated[index] = user;
                setNormalizedDebaters(updated);
                handleUserSelect(false, user, index, teamName);
              }}
            />
          );
        });

        globalIdx += slots;

        return (
          <div key={teamName} className={`${styles.teamSection} ${styles[getTeamColor(teamName.toLowerCase())]}`}>
            <div className={styles.teamHeaderRow}>
              <h3 className={styles.teamHeader}>
                Team: {teamName.charAt(0).toUpperCase() + teamName.slice(1)} ({filled}/{slots})
              </h3>
              <div className={styles.teamControls}>
                <Button variant="ghost" onClick={() => handleAdjust(teamIdx, -1)} disabled={teamSlots[teamIdx] === 0}>-</Button>
                <Button
                  variant="ghost"
                  onClick={() => handleAdjust(teamIdx, 1)}
                  disabled={teamSlots.reduce((a, b) => a + b, 0) >= totalSlots}
                >+
                </Button>
              </div>
            </div>
            <div className={styles.userFields}>{elements}</div>
          </div>
        );
      })}
    </div>
  );
};

export default DebaterAssign;
